import React from 'react'
import { Row, Col, Card } from 'antd';
import { IconHelper, routersHelper } from '../../helpers'
import TableDetail from './TableDetail'
import { translate } from 'react-i18next'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

const HistoryInfo = ({ t }) => {
    const paymentHistoryList = useSelector(state => state.paymentHistory.paymentHistoryList)
    const { useRouter } = routersHelper
    const router = useRouter()
    const { IconBack } = IconHelper

    const handleBack = () => {
        router.push('/portal/profile')
    }

    return (
        <Row type="flex" justify="center">

            <Col xl={8} lg={10} md={16} sm={20} xs={22}>
                <Card className="card-payment">
                    <Row>
                        <Col span={24} className="card-payment-back">
                            <IconBack style={{ cursor: 'pointer', marginRight: 10 }} onClick={handleBack} />
                            <span>{t("user_profile.header")}</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} className="card-payment-header">
                            <label>{t("payment_history.header")}</label>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} className="card-payment-detail" style={!isEmpty(paymentHistoryList) ? { marginBottom: -65 } : { minHeight: 300 }}>
                            <TableDetail paymentHistoryList={paymentHistoryList} />
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row >
    )
}

export default translate()(HistoryInfo)